import React, { useCallback } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { useOvertimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/store/overtimeDashboard.store';
import { OVERTIME_TREND_PERIOD_OPTIONS } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/OvertimeDashboard.constants';
import { TrendPeriodSelect } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/OtTrendPeriodSelect.styled';

export const OtTrendPeriodSelect: React.FC = () => {
  const { t } = useTranslation();
  const trendPeriods = useOvertimeDashboardStore((s) => s.trendPeriods);
  const setTrendPeriods = useOvertimeDashboardStore((s) => s.setTrendPeriods);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      setTrendPeriods(Number(event.target.value));
    },
    [setTrendPeriods],
  );

  return (
    <TrendPeriodSelect
      value={trendPeriods}
      onChange={handleChange}
      aria-label={t('reports:OVERTIME_TREND_PERIOD_LABEL')}
    >
      {OVERTIME_TREND_PERIOD_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {t(option.labelKey)}
        </option>
      ))}
    </TrendPeriodSelect>
  );
};
